<template>
  <div class="cautionTemplate">
    <div class="cautionTemplateContent">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CautionTemplate',
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.cautionTemplate {
  background-color: #fff2f2;
  border-radius: 4px;
  min-height: 45px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
}

.cautionTemplateContent {
  color: #e62525;
  font-size: $text-size-paragraph2;
  font-weight: $text-weight-bold;
}
</style>
